import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { ServiceResult } from '../types/common/ServiceResult';
import type {
  TopCategoryViewModel,
  TopCategoryCreateModel,
  TopCategoryUpdateModel,
} from '../types/top-category';
import { apiClient } from '../client/client';

export class TopCategoryService {
  private static readonly BASE = '/api/top-category';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(): Promise<ServiceResultT<TopCategoryViewModel[]>> {
    const { data } = await this.client.get<ServiceResultT<TopCategoryViewModel[]>>(
      TopCategoryService.BASE
    );
    return data;
  }

  async getById(id: number | string): Promise<ServiceResultT<TopCategoryViewModel>> {
    const { data } = await this.client.get<ServiceResultT<TopCategoryViewModel>>(
      `${TopCategoryService.BASE}/${id}`
    );
    return data;
  }

  async create(payload: TopCategoryCreateModel): Promise<ServiceResultT<TopCategoryViewModel>> {
    const { data } = await this.client.post<ServiceResultT<TopCategoryViewModel>>(
      TopCategoryService.BASE,
      payload
    );
    return data;
  }

  async update(
    id: number | string,
    payload: TopCategoryUpdateModel
  ): Promise<ServiceResultT<TopCategoryViewModel>> {
    const { data } = await this.client.put<ServiceResultT<TopCategoryViewModel>>(
      `${TopCategoryService.BASE}/${id}`,
      payload
    );
    return data;
  }

  async delete(id: number | string): Promise<ServiceResult> {
    const { data } = await this.client.delete<ServiceResult>(`${TopCategoryService.BASE}/${id}`);
    return data;
  }

  /**
   * GET /api/top-category/populated
   */
  async getPopulated(): Promise<ServiceResultT<TopCategoryViewModel[]>> {
    const { data } = await this.client.get<ServiceResultT<TopCategoryViewModel[]>>(
      `${TopCategoryService.BASE}/populated`
    );
    return data;
  }
}

export const topCategoryService = new TopCategoryService();
